export default "__VITE_ASSET__CMO3LYxv__"